<template>
  <page back class="home-page">
    <div class="charger-page">
      <!-- Header -->
      <div class="header">
        <div class="back-btn">
          ←
        </div>
        <div class="brand">AMPTRA</div>
      </div>

      <div class="title">Charger Details</div>

      <!-- 店铺卡片 -->
      <div class="store-card">
        <!-- <img class="store-img" src="@/assets/store.jpg" /> -->
        <div class="store-info">
          <div class="store-name">Choffi Kitchen</div>
          <div class="store-address">
            Marienplatz 22 Hugendubel 6. Stock
          </div>
        </div>
      </div>

      <!-- 价格卡片 -->
      <div class="pricing-wrapper">
        <div class="pricing-box">
          <div class="pricing-title">Rental Pricing</div>

          <div class="pricing-item">· First 3 minutes free</div>
          <div class="pricing-item">· $4.00 per 30 minutes</div>
          <div class="pricing-item">· Maximum daily charge: $15</div>
        </div>

        <div class="policy">
          <div class="policy-title">Deposit & Non-Return Policy</div>
          <div class="policy-price">
            $40.00 temporary deposit (pre-authorization)
          </div>
          <div class="policy-desc">
            This is NOT a final charge & Released after return<br />
            Processing time may take 3-8 business days, depending on your
            bank<br />
            If a charger is not returned within 3 days, the deposit is retained.
          </div>
        </div>
      </div>

      <!-- 说明 -->
      <div class="bottom-desc">
        Return to ANY AMPTRA station.<br />
        Universal Cables Included
      </div>

      <!-- 线缆图标 -->
      <div class="cable-icons">
        <div class="cable-item">
          <div class="icon"></div>
          <div>ios</div>
        </div>
        <div class="cable-item">
          <div class="icon"></div>
          <div>Micro</div>
        </div>
        <div class="cable-item">
          <div class="icon"></div>
          <div>Type-c</div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="bottom-btn">
        BEGIN RENTAL
      </div>
    </div>
  </page>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  computed: {
    // ShopDetails
    ...mapState(["qrcode", "zhcode", "cabinet", "browser", "user", "system"]),
    i18n() {
      return this.$t("home");
    },
    i18nMsg() {
      return this.$t("msg");
    }
  },
  data() {
    return {
      isScan: false,
      userAgreement: false,
      privacyAgreement: false
    };
  },
  methods: {
    goRouter(path) {
      this.$router.push(path);
    },
    // 頭部主頁圖標按鈕
    goHome() {
      this.$store.commit("qrcode", "");
      // console.log('ditu', gMapContext)
      this.isScan = false;
    }
  },
  created() {}
};
</script>

<style lang="less" scoped>
.charger-page {
  background: #f5f5f5;
  min-height: 100vh;
  padding: 0 0.32rem 1.6rem;
}

/* Header */

.header {
  position: relative;
  text-align: center;
  padding-top: 0.4rem;

  .back-btn {
    position: absolute;
    left: 0;
    top: 0.4rem;
    width: 0.8rem;
    height: 0.8rem;
    background: #eee;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.36rem;
  }

  .brand {
    font-size: 0.28rem;
    color: #f4a000;
    letter-spacing: 0.08rem;
  }
}

.title {
  font-size: 0.48rem;
  font-weight: bold;
  margin: 0.4rem 0;
}

/* 店铺卡片 */

.store-card {
  background: #fff;
  border-radius: 0.32rem;
  overflow: hidden;
  box-shadow: 0 0.08rem 0.2rem rgba(0, 0, 0, 0.05);

  .store-img {
    width: 100%;
    height: 3rem;
    object-fit: cover;
  }

  .store-info {
    padding: 0.32rem;

    .store-name {
      font-size: 0.36rem;
      font-weight: bold;
      margin-bottom: 0.1rem;
    }

    .store-address {
      font-size: 0.26rem;
      color: #888;
    }
  }
}

/* 价格区域 */

.pricing-wrapper {
  margin-top: 0.4rem;
  border: 1px dashed #f4a000;
  border-radius: 0.32rem;
  padding: 0.32rem;
  background: #fff;
}

.pricing-box {
  background: #f5efe4;
  border-radius: 0.24rem;
  padding: 0.32rem;
  text-align: center;

  .pricing-title {
    font-size: 0.34rem;
    font-weight: bold;
    margin-bottom: 0.2rem;
  }

  .pricing-item {
    font-size: 0.28rem;
    color: #f4a000;
    margin-bottom: 0.12rem;
  }
}

.policy {
  margin-top: 0.32rem;

  .policy-title {
    font-weight: bold;
    font-size: 0.28rem;
    margin-bottom: 0.12rem;
  }

  .policy-price {
    font-size: 0.28rem;
    font-weight: 600;
    margin-bottom: 0.12rem;
  }

  .policy-desc {
    font-size: 0.24rem;
    color: #888;
    line-height: 1.6;
  }
}

.bottom-desc {
  text-align: center;
  margin: 0.4rem 0 0.2rem;
  font-size: 0.28rem;
}

.cable-icons {
  display: flex;
  justify-content: space-around;
  margin-bottom: 0.6rem;

  .cable-item {
    text-align: center;
    font-size: 0.24rem;

    .icon {
      width: 0.6rem;
      height: 0.6rem;
      background: #ccc;
      margin: 0 auto 0.1rem;
      border-radius: 0.1rem;
    }
  }
}

.bottom-btn {
  position: fixed;
  bottom: 0.4rem;
  left: 0.32rem;
  right: 0.32rem;
  height: 0.96rem;
  background: #000;
  color: #fff;
  border-radius: 0.48rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.32rem;
  font-weight: bold;
}
</style>
